import React, { useState, useEffect } from "react";

const ColumnModal = ({ selectedColumns, setSelectedColumns, allColumns, onClose }) => {
    const [columns, setColumns] = useState([]);
    const [updatedCols, setUpdatedCols] = useState(selectedColumns)

    useEffect(() => {
        setColumns(allColumns);
    }, [allColumns]);

    const toggleColumn = (columnId) => {
        setUpdatedCols((prev) =>
            prev.includes(columnId)
                ? prev.filter((col) => col !== columnId)
                : [...prev, columnId]
        );
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white w-full max-w-md p-6 rounded-lg shadow-lg">
                <h3 className="text-lg font-medium text-primary mb-4">Select Columns</h3>
                <div className="space-y-4">
                    {columns.map((column) => (
                        <div key={column.value} className="flex items-center">
                            <input
                                type="checkbox"
                                id={column.value}
                                checked={updatedCols.includes(column.value)}
                                onChange={() => toggleColumn(column.value)}
                                className="h-4 w-4 border-gray-300 rounded"
                            />
                            <label htmlFor={column.value} className="ml-2 text-gray-700">
                                {column.label}
                            </label>
                        </div>
                    ))}
                </div>
                <div className="mt-6 flex justify-between gap-3">
                    <button
                        onClick={onClose}
                        className="bg-gray-400 text-white px-4 py-2 rounded-md hover:bg-gray-500"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => { setSelectedColumns(updatedCols); onClose() }}
                        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ColumnModal;
